//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BaseLoading',
  props: {
    variant: {
      required: false,
      type: String,
      default: 'primary',
      validator: function validator(value) {
        return ['primary', 'secondary', 'danger', 'warning', 'success', 'info', 'light', 'dark'].indexOf(value) !== -1;
      }
    },
    type: {
      required: false,
      type: String,
      default: 'border',
      validator: function validator(value) {
        return ['border', 'grow'].indexOf(value) !== -1;
      }
    },
    messageLoading: {
      required: false,
      type: String,
      default: 'Loading...'
    }
  }
};